import BaseApiService from './BaseApiService.js';

class HostelService extends BaseApiService {
  // ✅ Create new hostel
  async createHostel(hostelData) {
    console.log('🚀 HostelService.createHostel() - Sending to API:', hostelData);
    console.log('🚀 Total Rooms:', hostelData.totalRooms, 'Type:', typeof hostelData.totalRooms);
    console.log('🚀 Beds Per Room:', hostelData.bedsPerRoom, 'Type:', typeof hostelData.bedsPerRoom);
    return this.makeRequest('/api/admin/hostel/create', {
      method: 'POST',
      body: JSON.stringify(hostelData),
    });
  }

  // ✅ List all hostels
  async listHostels() {
    return this.makeRequest('/api/admin/hostel/list');
  }

  // ✅ Get hostel details
  async getHostelDetails(hostelId) {
    return this.makeRequest(`/api/admin/hostel/${hostelId}`);
  }

  // ✅ Update hostel
  async updateHostel(hostelId, hostelData) {
    return this.makeRequest(`/api/admin/hostel/${hostelId}/update`, {
      method: 'PUT',
      body: JSON.stringify(hostelData),
    });
  }

  // ✅ Delete hostel
  async deleteHostel(hostelId) {
    return this.makeRequest(`/api/admin/hostel/${hostelId}/delete`, {
      method: 'DELETE',
    });
  }

  // ✅ Create hostel room
  async createHostelRoom(hostelId, roomData) {
    return this.makeRequest(`/api/admin/hostel/${hostelId}/rooms/create`, {
      method: 'POST',
      body: JSON.stringify(roomData),
    });
  }

  // ✅ List rooms for a hostel
  async listHostelRooms(hostelId) {
    return this.makeRequest(`/api/admin/hostel/${hostelId}/rooms/list`);
  }

  // ✅ Update hostel room
  async updateHostelRoom(roomId, roomData) {
    return this.makeRequest(`/api/admin/hostel/rooms/${roomId}/update`, {
      method: 'PUT',
      body: JSON.stringify(roomData),
    });
  }

  // ✅ Delete hostel room
  async deleteHostelRoom(roomId) {
    return this.makeRequest(`/api/admin/hostel/rooms/${roomId}/delete`, {
      method: 'DELETE',
    });
  }

  // ✅ Allocate hostel to student
  async allocateHostel(allocationData) {
    return this.makeRequest('/api/admin/hostel/allocate', {
      method: 'POST',
      body: JSON.stringify(allocationData),
    });
  }

  // ✅ Get all allocations
  async listAllAllocations() {
    return this.makeRequest('/api/admin/hostel/allocation/list');
  }

  // ✅ Get student's hostel allocation
  async getStudentAllocation(studentId) {
    if (!studentId) {
      return this.listAllAllocations();
    }
    return this.makeRequest(`/api/admin/hostel/student/${studentId}/allocation`);
  }

  // ✅ Remove hostel allocation
  async deallocateHostel(allocationId) {
    return this.makeRequest(`/api/admin/hostel/allocation/${allocationId}/deallocate`, {
      method: 'POST',
    });
  }

  // ✅ Request hostel gatepass
  async requestGatepass(gatepassData) {
    return this.makeRequest('/api/admin/hostel/gatepass/request', {
      method: 'POST',
      body: JSON.stringify(gatepassData),
    });
  }

  // ✅ Approve gatepass
  async approveGatepass(gatepassId) {
    return this.makeRequest(`/api/admin/hostel/gatepass/${gatepassId}/approve`, {
      method: 'POST',
    });
  }

  // ✅ Record exit
  async recordExit(gatepassId) {
    return this.makeRequest(`/api/admin/hostel/gatepass/${gatepassId}/exit`, {
      method: 'POST',
    });
  }

  // ✅ Record return
  async recordReturn(gatepassId) {
    return this.makeRequest(`/api/admin/hostel/gatepass/${gatepassId}/return`, {
      method: 'POST',
    });
  }

  // ✅ Reject gatepass
  async rejectGatepass(gatepassId) {
    return this.makeRequest(`/api/admin/hostel/gatepass/${gatepassId}/reject`, {
      method: 'POST',
    });
  }

  // ✅ Cancel gatepass
  async cancelGatepass(gatepassId) {
    return this.makeRequest(`/api/admin/hostel/gatepass/${gatepassId}/cancel`, {
      method: 'POST',
    });
  }

  // ✅ List all gatepasses
  async listGatepasses() {
    return this.makeRequest('/api/admin/hostel/gatepass/list');
  }

  // ✅ List all rooms in the organization
  async listAllRooms() {
    return this.makeRequest('/api/admin/hostel/room/list');
  }
}

// ✅ Export single instance
const hostelService = new HostelService();
export default hostelService;
